export const filter = {
  id : '',  
  location_name: '', 
  branch_id: '', 
  created_at: '',
  updated_at: ''  
};
